<template>
  <section class="hero has-bg-img mb-20">
    <!-- Hero head: will stick at the top -->
    <div class="hero-head">
      <nav class="navbar is-fresh">
        <div class="container">
          <div class="navbar-brand">
            <router-link class="navbar-item" to="/">
              <img
                src="../assets/logo_takima_horizontal_inverted-1.png"
                alt=""
              />
            </router-link>
          </div>
          <div id="navbar-menu" class="navbar-menu is-static">
            <div class="navbar-end">
              <language-switcher class="navbar-item" />
            </div>
          </div>
        </div>
      </nav>
    </div>
    <!-- Hero content: will be in the middle -->
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1
          class="title"
          style="
            color: #fff;
            letter-spacing: 7px;
            line-height: 1.5;
            font-weight: 500;
            margin: 85px auto 0;
            max-width: 800px;
            text-transform: uppercase;
            font-size: 1.35em;
          "
        >
          {{ title }}
        </h1>
        <h2 class="subtitle">
          {{ year }}
        </h2>
      </div>
    </div>
    <div style="display: flex; margin: auto">
      <div
        style="
          z-index: 1;
          background-color: rgb(255, 255, 255);
          position: relative;
          top: 50px;
          padding: 5px;
          border-radius: 100%;
          vertical-align: middle;
          display: inline-grid;
        "
      >
        <img
          src="../assets/logo_takima.png"
          style="
            max-width: 90px;
            border-radius: 50%;
            background-color: rgba(52, 59, 64, 0.9);
            padding: 6px;
          "
        />
      </div>
      <div
        style="
          background-color: #fff;
          position: relative;
          top: 73px;
          left: -8px;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
        "
      >
        <div
          style="
            color: #fff;
            text-overflow: hidden;
            white-space: nowrap;
            background-color: rgba(52, 59, 64, 0.9);
            position: relative;
            height: 50px;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            letter-spacing: 12px;
            padding: 10px 15px 0 30px;
            text-transform: uppercase;
            border-top: 5px solid #fff;
            border-right: 5px solid #fff;
            font-weight: bold;
          "
        >
          {{ subtitle }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LanguageSwitcher from '@/layout/LanguageSwitcher.vue'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'MainNavbar',
  components: {
    'language-switcher': LanguageSwitcher
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    title: function () {
      if (this.$i18n.locale === 'en' && this.$route.meta.titleen) {
        return this.$route.meta.titleen
      } else {
        return this.$route.meta.titlefr
      }
    },
    year: function () {
      return this.$route.meta.year
    },
    subtitle: function () {
      return this.$route.meta.subtitle
    }
  }
}
</script>

<style scoped>
h2.subtitle {
  color: white !important;
  padding-top: 20px;
}
</style>
